export default __webpack_public_path__ + "static/media/decada-2000-0004-min.3e320fd0.jpg";